<template>
  <div class="bigBox">
    <div class="container" @click.stop="boxClick">
      <router-link to="/userSetting" style="color: #333">
        <div class="info-box">
          <div class="ib_left">
            <van-image
              fit="cover"
              :src="userInfo.Photo"
              round
              error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
            />
            <div>
              <div class="nickName">{{ userInfo.NickName }}</div>
            </div>
          </div>
          <div class="iconfont icon-right"></div>
        </div>
      </router-link>
      <div class="record-box">
        <div>
          <router-link to="/myTopic"
            ><div>{{ contentInfo.TotalTopics }}</div>
            <div style="color: #aaa">话题</div></router-link
          >
        </div>
        <div @click="toHomePage(userInfo.MemberID)">
          <div>{{ contentInfo.TotalPosts }}</div>
          <div>动态</div>
        </div>
        <div>
          <router-link :to="{ name: 'myAttention', query: { type: 1 } }">
            <div>{{ contentInfo.TotalFans }}</div>
            <div style="color: #aaa">粉丝</div>
          </router-link>
        </div>
        <div>
          <router-link :to="{ name: 'myAttention', query: { type: 0 } }"
            ><div>{{ contentInfo.TotalFollows }}</div>
            <div style="color: #aaa">关注</div></router-link
          >
        </div>
      </div>

      <div
        class="handle-box"
        v-if="
          userInfo.StoreId > 0 ||
          userInfo.CardStatus >= 0 ||
          userInfo.IsStore == 1
        "
      >
        <router-link
          v-if="userInfo.StoreId > 0"
          class="line"
          :to="{ name: 'storeShow', query: { mid: userInfo.StoreId } }"
        >
          <div class="l_light red">
            <div class="iconfont icon-dian"></div>
          </div>
          <div class="l_right">
            <div>展厅</div>
            <div class="iconfont icon-right"></div>
          </div>
        </router-link>
        <router-link
          class="line"
          to="/myPostcard"
          v-if="userInfo.CardStatus >= 0"
        >
          <div class="l_light blue">
            <div class="iconfont icon-mingpian"></div>
          </div>
          <div class="l_right">
            <div>名片</div>
            <div class="iconfont icon-right"></div>
          </div>
        </router-link>
        <mini-program
          class="line"
          path="/subpackage/pages/contactGuide/contactGuide"
          v-if="userInfo.IsStore == 1"
        >
          <div class="l_light blue">
            <div class="iconfont icon-mingpian"></div>
          </div>
          <div class="l_right">
            <div>展厅名片管理</div>
            <div class="iconfont icon-right"></div>
          </div>
        </mini-program>
      </div>

      <div class="handle-box">
        <router-link class="line" to="/giveLike">
          <div class="l_light green">
            <div class="iconfont icon-favorites"></div>
          </div>
          <div class="l_right">
            <div>点赞</div>
            <div class="iconfont icon-right"></div>
          </div>
        </router-link>
        <router-link class="line" to="/collection">
          <div class="l_light red">
            <div class="iconfont icon-collection"></div>
          </div>
          <div class="l_right">
            <div>收藏</div>
            <div class="iconfont icon-right"></div>
          </div>
        </router-link>
        <router-link class="line" to="/comment">
          <div class="l_light yellow">
            <div class="iconfont icon-pinglun1"></div>
          </div>
          <div class="l_right">
            <div>评论</div>
            <div class="iconfont icon-right"></div>
          </div>
        </router-link>
        <router-link class="line" to="/history">
          <div class="l_light blue">
            <div class="iconfont icon-lishi"></div>
          </div>
          <div class="l_right">
            <div>浏览历史</div>
            <div class="iconfont icon-right"></div>
          </div>
        </router-link>
      </div>

      <div class="handle-box">
        <router-link class="line" to="/phoneLogin">
          <div class="l_light blue">
            <div class="iconfont icon-mutual" style="font-size: 16px"></div>
          </div>
          <div class="l_right">
            <div>切换账户</div>
            <div class="iconfont icon-right"></div>
          </div>
        </router-link>
        <div class="line" @click.stop="exitCurrentAccount">
          <div class="l_light red">
            <div class="iconfont icon-account1" style="font-size: 16px"></div>
          </div>
          <div class="l_right">
            <div style="color: #d62f2f">退出当前账户</div>
            <div class="iconfont icon-right"></div>
          </div>
        </div>
      </div>
    </div>
    <FooterTab ref="childData"></FooterTab>
  </div>
</template>
<script>
import { Image } from "vant";
import FooterTab from "@/components/FooterTab";
import miniProgram from "@/components/miniProgram";
import { loginInfo, memberContentInfo } from "@/api/member";
export default {
  name: "member",
  components: {
    FooterTab,
    miniProgram,
    "van-image": Image,
  },
  data() {
    return {
      userInfo: "",
      contentInfo: "",
    };
  },
  methods: {
    //点击其他空白，隐藏发布按钮
    boxClick() {
       this.$refs["childData"].publishBtn = false;
    },
    //获取个人信息
    getPersonInfo() {
      var data = {};
      loginInfo(data).then((res) => {
        this.userInfo = res.Data;
        this.getMemberInfo();
      });
    },

    //获取会员内容数据
    getMemberInfo() {
      var data = {};
      memberContentInfo(data).then((res) => {
        this.contentInfo = res.Data;
      });
    },

    //跳转个人主页
    toHomePage(mid) {
      this.$router.push({ path: "/homePage", query: { mid: mid } });
    },

    //退出登录
    exitCurrentAccount() {
      localStorage.removeItem("token");
      localStorage.removeItem("mid");
      this.$router.push("/");
    },
  },
  created() {
    this.$store.commit("setFooterNav", "member");
  },
  mounted() {
    this.getPersonInfo();
  },
  updated() {},
};
</script>
<style lang="less" scoped>
.bigBox {
  background: #f5f5f5;
  min-height: 100vh;
  .container {
    padding-bottom: 70px;
    box-sizing: border-box;
    .info-box {
      height: 107px;
      background: #ffffff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px 0 25px;
      .ib_left {
        display: flex;
        align-items: center;
        font-size: 10px;
        color: #aaa;
        div {
          width: 230px;
          .nickName {
            color: #333333;
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 5px;
            line-height: 20px;
          }
        }
        .van-image {
          display: block;
          width: 60px;
          height: 60px;
          margin-right: 12px;
        }
      }
    }
    .record-box {
      padding: 15px 0 27px 0;
      display: flex;
      align-items: center;
      background: #ffffff;
      div {
        flex: 1;
        text-align: center;
        color: #aaa;
        font-size: 12px;
        div {
          &:first-child {
            font-size: 17px;
            color: #333333;
          }
        }
      }
    }
    .handle-box {
      margin-top: 10px;
      padding: 6px 0;
      background: #ffffff;
      .line {
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &:first-child {
          .l_right {
            border-top: 0;
          }
        }
        .l_light {
          width: 25px;
          height: 25px;
          border-radius: 50%;
          text-align: center;
          line-height: 25px;
          color: #fff;
          font-size: 15px;
          margin-left: 20px;
        }
        .red {
          background: #df5e5e;
        }

        .blue {
          background: #5999cf;
        }

        .green {
          background: #71c589;
        }

        .yellow {
          background: #d9a55b;
        }
        .l_right {
          padding-right: 20px;
          box-sizing: border-box;
          width: 318px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-top: 1px solid #eeeeee;
          font-size: 14px;
          color: #333333;
          .icon-right {
            font-size: 12px;
            color: #999;
          }
        }
      }
    }
  }
}
</style>
